import {makeStyles} from "@material-ui/core/styles";
import {useDispatch} from "react-redux";
import {ListItemIcon, Menu, MenuItem} from "@material-ui/core";
import {setOpenedImport, setSelectedRecord} from "../../../reducers/applicationBuilder.slice";
import {Edit, Publish} from "@material-ui/icons";
import React from "react";
import {useHistory} from "react-router";

const useContextStyles = makeStyles(() => ({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    }
}))
const ContextMenu = ({anchorEl, onClose, createNew}) => {
    const classes = useContextStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    return (
        <Menu
            open={anchorEl.mouseY !== null}
            classes={{list: classes.contextPaper}}
            anchorReference={"anchorPosition"}
            anchorPosition={
                anchorEl.mouseY !== null && anchorEl.mouseX !== null
                    ? {top: anchorEl.mouseY, left: anchorEl.mouseX}
                    : undefined
            }
            onClose={onClose}
        >
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    dispatch(setSelectedRecord({type: anchorEl.type}))
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Edit fontSize="small"/>
                </ListItemIcon>
                Create new {anchorEl.type}
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    dispatch(setOpenedImport(anchorEl.type))
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Publish fontSize="small"/>
                </ListItemIcon>
                Import
            </MenuItem>
            {(anchorEl.type === 'entity' && anchorEl.recordId) && (
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        dispatch(setSelectedRecord({type: 'content', id: anchorEl.recordId}))
                        onClose();
                    }}
                >
                    <ListItemIcon classes={{root: classes.listIconRoot}}>
                        <Edit fontSize="small"/>
                    </ListItemIcon>
                    Content Editor
                </MenuItem>
            )}
        </Menu>
    )
}
export default ContextMenu